import { render } from "./IssueDetailPanel.vue?vue&type=template&id=d0a0b0fa&scoped=true"
import script from "./IssueDetailPanel.vue?vue&type=script&lang=js"
export * from "./IssueDetailPanel.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d0a0b0fa"

export default script